<template>
  <div class="app-container">
    <!-- 侧边导航栏 -->
    <Sidebar :isHide="isHide" />
    <!-- 顶部栏 -->
    <header class="top-bar">
      <img src="../assets/image/logo.png" alt="logo" class="logo-area">
      <div class="time-area">
        <img src="../assets/image/time.png" alt="" class="time">
        <span class="dateDay">{{ dateDay }}</span>
        <div class="date">
          <div>{{ dateYear }}</div>
          <div>{{ dateWeek }}</div>
        </div>
      </div>
    </header>
    <main class="main">
      <router-view/>
    </main>
    <!-- 底部栏 -->
    <footer class="bottom-bar">
      绍兴衡业工程管理咨询有限公司 © 2026 | 智能驱动未来
    </footer>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue' // 引入侧边栏组件
import { formatTime } from '@/utils/index.js'
export default {
  name: 'Index',
  components: { Sidebar },
  data () {
    return {
      timing: null,
      loading: false,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      isHide: true
    }
  },
  watch: {
    // 监听路由变化，更新首页判断状态
    $route: {
      handler (to, from) {
        this.isHide = to.path === '/home'
        console.log(this.isHide)
      },
      immediate: true
    }
  },
  mounted () {
    this.timeFn()
  },
  beforeDestroy () {
    clearInterval(this.timing)
  },
  methods: {
    // 切换折叠状态
    toggleCollapse () {
      this.isHide = !this.isHide
    },
    timeFn () {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH: mm: ss')
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd')
        this.dateWeek = this.weekday[new Date().getDay()]
      }, 1000)
    }
  }
}
</script>

<style scoped lang="scss">
/* 全局容器样式 */
.app-container {
  min-height: 100vh;
  font-family: "Microsoft Yahei", sans-serif;
  background-image: url("@/assets/image/bg.png");
  background-size: 100% 100%;
  /* 顶部栏样式 */
  .top-bar {
    position: relative;
    height: 100px;
    margin: 0 100px;
    background-image: url("@/assets/image/titleBg.png");
    background-size: 100% 100%;
    .logo-area {
      width: 433px;
      height: auto;
      position: absolute;
      left: 13px;
      top: 34px;
    }
    .time-area {
      position: absolute;
      right: 13px;
      top: 60px;
      display: flex;
      align-items: center;
      .time{
        width: 26px;
        height: 26px;
      }
      .dateDay{
        font-weight: bold;
        font-size: 24px;
        color: #000000;
        line-height: 30px;
        margin:0 20px;
      }
      .date{
        font-weight: 400;
        font-size: 16px;
        color: #000000;
        line-height: 18px;
        padding-left: 20px;
        border-left: 1px solid #000;
      }
    }
  }
}
.main {
  //height: calc(100vh - 185px);
  min-height: calc(100vh - 185px);
  //overflow: auto;
}
/* 底部栏样式 */
.bottom-bar {
  text-align: center;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: 400;
  font-size: 18px;
  color: #000000;
  height: 80px;
  line-height: 80px;
}
</style>
